import React from 'react';
import './ImageBanner.css';
import LogoCarousel from '../LogoCarousel/LogoCarousel';

// Mise à jour de la liste des logos avec vos fichiers spécifiques
const bannerLogos = [
  { id: 'l1', src: `${process.env.PUBLIC_URL}/images/logo1.png`, alt: 'Logo Partenaire 1' },
  { id: 'l2', src: `${process.env.PUBLIC_URL}/images/logo2.png`, alt: 'Logo Partenaire 2' },
  { id: 'l3', src: `${process.env.PUBLIC_URL}/images/logo3.png`, alt: 'Logo Partenaire 3' },
  { id: 'l4', src: `${process.env.PUBLIC_URL}/images/logo4.png`, alt: 'Logo Partenaire 4' },
  { id: 'l5', src: `${process.env.PUBLIC_URL}/images/logo5.png`, alt: 'Logo Partenaire 5' },
  { id: 'l6', src: `${process.env.PUBLIC_URL}/images/logo6.png`, alt: 'Logo Partenaire 6' },
  { id: 'l7', src: `${process.env.PUBLIC_URL}/images/logo7.png`, alt: 'Logo Partenaire 7' },
  { id: 'l8', src: `${process.env.PUBLIC_URL}/images/logo8.png`, alt: 'Logo Partenaire 8' },
  { id: 'l9', src: `${process.env.PUBLIC_URL}/images/logo9.webp`, alt: 'Logo Partenaire 9' },
  { id: 'l10', src: `${process.env.PUBLIC_URL}/images/logo10.png`, alt: 'Logo Partenaire 10' },
  { id: 'l11', src: `${process.env.PUBLIC_URL}/images/logo11.png`, alt: 'Logo Partenaire 11' },
  { id: 'l12', src: `${process.env.PUBLIC_URL}/images/logo12.png`, alt: 'Logo Partenaire 12' },
  { id: 'l13', src: `${process.env.PUBLIC_URL}/images/logo13.png`, alt: 'Logo Partenaire 13' },
  { id: 'l14', src: `${process.env.PUBLIC_URL}/images/logo14.png`, alt: 'Logo Partenaire 14' },
  { id: 'l15', src: `${process.env.PUBLIC_URL}/images/logo15.png`, alt: 'Logo Partenaire 15' },
  { id: 'l16', src: `${process.env.PUBLIC_URL}/images/logo16.png`, alt: 'Logo Partenaire 16' },
  { id: 'l17', src: `${process.env.PUBLIC_URL}/images/logo17.png`, alt: 'Logo Partenaire 17' },
  { id: 'l18', src: `${process.env.PUBLIC_URL}/images/logo18.png`, alt: 'Logo Partenaire 18' },
  { id: 'l19', src: `${process.env.PUBLIC_URL}/images/logo19.png`, alt: 'Logo Partenaire 19' },
];

function ImageBanner() {
  return (
    <div className="image-banner-section">
      <img
        className="banner-background-image"
        src={process.env.PUBLIC_URL + '/images/header.png'} // L'image de fond de la bannière
        alt="Bannière Info-Alt"
      />
      {/* Le carrousel est positionné par-dessus via CSS */}
      {bannerLogos && bannerLogos.length > 0 && <LogoCarousel logos={bannerLogos} />}
    </div>
  );
}

export default ImageBanner;